module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_600.e68ac74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surveys/fullscreen-image_hero_600.png
// module id = 2kct
// module chunks = 0